module.exports = __webpack_public_path__ + "public/images/blob-left.dd4afebf4e3bc18ec4780892424eb6f8.png";